module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture37-9f513f3e100ac5ec6d7d8cb675fa5ede.jpg";